import { createAction, props } from '@ngrx/store';
import { DebitNoteModel } from '@shared/data-access/models';

export const loadItem = createAction('[DEBIT NOTE] LOAD ITEM', props<{ id: number }>());
export const loadItemSuccess = createAction('[DEBIT NOTE] LOAD ITEM SUCCESS', props<{ item: DebitNoteModel }>());
